import React from 'react';
import { Alert, Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  RadarCandidatesSection,
  RadarEvidenceBoard,
  RadarFilters,
  RadarHero,
  RadarHistoryPanel,
  RadarOverview,
  RadarQualityBreakdown,
  RadarSectorsPanel,
  useMarketInternalRadarDashboard,
} from '../components/market-internal-radar';

function MarketInternalRadarScreen() {
  const { t, i18n } = useTranslation();
  const {
    locale,
    loading,
    refreshing,
    error,
    summary,
    candidatesPayload,
    sectors,
    history,
    filters,
    handleFilterChange,
    applyFilters,
    refresh,
  } = useMarketInternalRadarDashboard({ t, language: i18n.language });

  return (
    <Box sx={{ px: { xs: 0, md: 0.5 }, py: 1.25 }}>
      <Stack spacing={1.25}>
        <RadarHero
          summary={summary}
          candidateSummary={candidatesPayload?.summary}
          loading={loading}
          refreshing={refreshing}
          onRefresh={refresh}
          t={t}
          locale={locale}
        />

        {error ? <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert> : null}

        <RadarFilters
          filters={filters}
          onChange={handleFilterChange}
          onApply={applyFilters}
          loading={loading}
          t={t}
        />

        {/* Row A — single calm overview card replacing the 4-card row */}
        <RadarOverview
          summary={summary}
          candidateSummary={candidatesPayload?.summary}
          t={t}
        />

        {/* Row B — Quality breakdown: why this score? */}
        <RadarQualityBreakdown summary={summary} t={t} />

        {/* Row C — Verification evidence: concrete names */}
        <RadarEvidenceBoard summary={summary} t={t} lang={i18n.language} />

        {/* Row B — Candidates board, full width */}
        <RadarCandidatesSection
          candidatesPayload={candidatesPayload}
          loading={loading}
          t={t}
        />

        {/* Row C — Sectors + History stacked vertically so neither panel truncates */}
        <RadarSectorsPanel sectors={sectors} loading={loading} t={t} lang={i18n.language} />
        <RadarHistoryPanel history={history} loading={loading} t={t} locale={locale} />
      </Stack>
    </Box>
  );
}

export default function MarketInternalRadar() {
  return <MarketInternalRadarScreen />;
}